import { reflect } from '@effector/reflect';
import { Button, NumberInput } from '@mantine/core';
import { combine } from 'effector';
import { useUnit } from 'effector-react';
import { useTranslation } from 'react-i18next';
import { shiftsPageModel } from 'pages/shifts-page/model';
import { translated, $t, useBreakpoint } from 'shared/lib';
import { ShiftsPageShift } from '../shifts-page-shift';
import cls from './shifts-page-prev.module.scss';

const OpeningBalanceField = reflect({
	view: NumberInput,
	bind: {
		'data-test-id': 'shifts-page-opening-balance',
		value: shiftsPageModel.openingBalanceField.$value,
		onChange: (v) => shiftsPageModel.openingBalanceField.change(Number(v)),
		label: translated('shifts-page.opening-balance'),
		placeholder: '0.00',
		rightSection: shiftsPageModel.$currency,
		errorProps: { 'data-test-id': 'shifts-page-opening-balance-input-error' },
		error: combine(
			[shiftsPageModel.openingBalanceField.$errors, $t],
			([errors, t]) =>
				errors.length > 0 &&
				t(`errors:validation.${errors[0]}`, {
					fieldName: t('shifts-page.opening-balance'),
				}),
		),
	},
});

export const ShiftsPagePrev = () => {
	const { t } = useTranslation();

	const [shift, pending, submit] = useUnit([
		shiftsPageModel.$shift,
		shiftsPageModel.startShiftMutation.$pending,
		shiftsPageModel.form.submit,
	]);

	const sm = useBreakpoint('sm');

	return (
		<>
			<ShiftsPageShift shift={shift} />
			<form
				data-test-id='shifts-page-prev-form'
				className={cls.shiftsPagePrevForm}
				onSubmit={(e) => {
					e.preventDefault();
					submit();
				}}
			>
				<OpeningBalanceField size={sm ? '2xl' : 'xl'} />
				<Button
					type='submit'
					size={sm ? 'xl' : 'lg'}
					loading={pending}
				>
					{t('shifts-page.start-shift')}
				</Button>
			</form>
		</>
	);
};
